<mat-card class="table-container">
  <div *ngIf="title" class="mb-1">
    <h2>{{ title | i18n }}</h2>
  </div>

  <cdk-table [dataSource]="data" class="main-table" matSort (matSortChange)="sortData($event)">
    <ng-container *ngFor="
        let row of rows
          | paginate
            : {
                id: paginationId,
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
              }
      " [matColumnDef]="row.id">
      <cdk-header-cell [hidden]="isMobile" class="font-regular" [ngClass]="setClassToHeader(row)" *matHeaderCellDef
        [mat-sort-header]="row.id" [disabled]="!row.orderable" [ngStyle]="{ 'width': row.width + '%' }"><strong
          *ngIf="hideRowTitle(row)">{{ row.label | i18n }}</strong>
        <mat-checkbox *ngIf="row.type == 'checkbox'" color="primary" (change)="toggleCheckboxes($event.checked)">
        </mat-checkbox>
      </cdk-header-cell>
      <cdk-cell class="font-regular flex justify-content-between" [ngStyle]="{ 'width': row.width + '%' }"
        *matCellDef="let el">
        <div *ngIf="isMobile" class="column-title">{{ row.label | i18n }}</div>

        <div [ngSwitch]="row.type" class="full-height column-container w-full">
          <div *ngSwitchCase="'text'">
            <span [title]="el[row.id]">{{ el[row.id] }}</span>
          </div>
          <div class="text-right" *ngSwitchCase="'text_right'">
            <span>{{ el[row.id] }}</span>
          </div>
          <div *ngSwitchCase="'text_bold'">
            <strong>{{ el[row.id] }}</strong>
          </div>
          <div *ngSwitchCase="'array_field'">
            <rfc-array-column [arrayInput]="el[row.id].array" [labelInput]="el[row.id].label"></rfc-array-column>
          </div>
          <div *ngSwitchCase="'chip'" class="chip-container">
            <div class="chip" [ngStyle]="getChipStyle(el[row.id])">
              {{ el[row.id].text }}
            </div>
          </div>
          <div *ngSwitchCase="'chip-click'" class="chip-container">
            <div class="chip pointer" (click)="actionDetailSelected(el, row, true)"
              [ngStyle]="getChipStyle(el[row.id])">
              {{ el[row.id].text }}
            </div>
          </div>
          <div *ngSwitchCase="'toggle'">
            <mat-slide-toggle color="primary" [checked]="el[row.id]"></mat-slide-toggle>
          </div>
          <div *ngSwitchCase="'vehicle'" class="vehicle-container">
            <rfc-vehicle-column [vehicle]="el[row.id]"></rfc-vehicle-column>
          </div>
          <div *ngSwitchCase="'icon_chips_text'" class="full-height">
            <rfc-icon-chips-text [ict]="el[row.id]"></rfc-icon-chips-text>
          </div>
          <div *ngSwitchCase="'list'" class="full-height">
            <ul class="list-none">
              <li *ngFor="let el of el[row.id]">
                <a class="font-small">
                  {{ el }}
                </a>
              </li>
            </ul>
          </div>
          <div *ngSwitchCase="'driver_email'" class="full-height">
            <rfc-text-subtext-column [textSubText]="el[row.id]"></rfc-text-subtext-column>
          </div>
          <div *ngSwitchCase="'codPlate_expire'" class="full-height">
            <rfc-text-subtext-column [textSubText]="el[row.id]"></rfc-text-subtext-column>
          </div>
          <div *ngSwitchCase="'vehicle_detail'">
            <rfc-vehicle-detail-column [vehicle]="el[row.id]"></rfc-vehicle-detail-column>
          </div>
          <div *ngSwitchCase="'progress_bar'">
            <rfc-progress-bar [value]="el[row.id]"></rfc-progress-bar>
          </div>
          <div *ngSwitchCase="'vehicle_tires'">
            <rfc-tires-column [tires]="el[row.id]"></rfc-tires-column>
          </div>
          <div *ngSwitchCase="'action'">
            <rfc-action-column [actions]="el[row.id]" [navigationState]="navigationState"
              (navigateWithState)="mappingNavigateWithState($event, el)" class="cursor-pointer"></rfc-action-column>
          </div>
          <!-- action_icon -->
          <div *ngSwitchCase="'action_icon'">
            <div class="action-column cursor-pointer flex items-center justify-start gap-2">
              <rfc-icon *ngFor="let action of el[row.id]" [iconInput]="action.icon"
                (click)="emitClicked(action, null)"></rfc-icon>
            </div>
          </div>
          <!-- action_icon2 -->
          <!--action icon che riesce a portarsi dietro i dati della row della tabella in questione-->
          <div *ngSwitchCase="'action_icon2'">
            <div class="action-column flex items-center justify-start gap-2 cursor-pointer">
              <rfc-icon *ngFor="let action of el[row.id]" [iconInput]="action.icon"
                (click)="actionDetailSelected(el, row, true)"></rfc-icon>
            </div>
          </div>
          <div *ngSwitchCase="'text_link'">
            <span [title]="el[row.id]" (click)="emitClicked(el, 'text_link')"
              [ngClass]="getClassTextLinkStartingFromValues(el[row.id])">{{ el[row.id] }}</span>
          </div>
          <!--status-->
          <div *ngSwitchCase="'icon_list'">
            <rfc-icon *ngFor="let icon of el[row.id]" [iconInput]="icon"></rfc-icon>
          </div>
          <div *ngSwitchCase="'icon'">
            <div (click)="actionSelected(el, row)" [ngClass]="getClassStartingFromValues(el[row.id])">
              <rfc-icon [iconInput]="setIconAttributeForRendering(row, el)"></rfc-icon>
            </div>
          </div>
          <div *ngSwitchCase="'icon_action'">
            <div (click)="iconAction(el, row)" class="cursor-pointer">
              <rfc-icon [iconInput]="setIconAttributeForRendering(row, el)"></rfc-icon>
            </div>
          </div>
          <div *ngSwitchCase="'button_export'">
            <button mat-stroked-button (click)="emitClicked(el, null)" class="ald-mat-button"
              [ngClass]="{ 'with-icon': !!el[row.id].icon }">
              <div class="button-container flex justify-content-between">
                <mat-icon *ngIf="el[row.id].icon" fontSet="fa"
                  style="display: flex; justify-content: center; align-items: center;" [ngClass]="getIconColor(row, el)"
                  [fontIcon]="getButtonIconRow(row, el)"></mat-icon>
                <span class="font-regular flex items-center">{{
                  getButtonLabel(row, el) | i18n
                  }}</span>
              </div>
            </button>
          </div>
          <div *ngSwitchCase="'button'">
            <button mat-raised-button style="font-weight: 600; line-height: 14px;" class="ald-mat-button primary"
              [disabled]="el.actionDisable ? el.actionDisable : false" (click)="actionSelected(el, row, true)">
              {{ getButtonLabel(row, el) | i18n }}
            </button>
          </div>
          <div *ngSwitchCase="'button_detail'">
            <button mat-raised-button style="font-weight: 600; line-height: 14px;" class="ald-mat-button primary" (click)="actionDetailSelected(el, row, true)">
              {{ getButtonLabelDetail(row) | i18n }}
            </button>
          </div>
          <div *ngSwitchCase="'checkbox'">
            <mat-checkbox *ngIf="el['id']" color="primary" [value]="el['id']" [checked]="isChecked(el['id'])"
              (change)="toggleSelectionId(el['id'])"></mat-checkbox>
          </div>
          <div *ngSwitchCase="'radio'" class="radio-container">
            <mat-radio-button color="primary" (change)="radioSelected(el)"></mat-radio-button>
          </div>
          <div *ngSwitchCase="'custom'" [innerHTML]="el[row.id]"></div>
        </div>
      </cdk-cell>
    </ng-container>
    <cdk-header-row *matHeaderRowDef="displayedColumns"></cdk-header-row>

    <cdk-row class="flex justify-content-between" *matRowDef="let el; columns: displayedColumns"
      (click)="selectRow(el)"></cdk-row>

    <div class="table-norecords-alert mt-1" *matNoDataRow>
      {{ "table_norecords" | i18n }}
    </div>
  </cdk-table>

  <div class="footer-table flex items-center justify-start gap-2">
    <div *ngIf="massiveOperationObj" class="gap-0 gap-xs-[10px]">
      <button mat-raised-button [ngStyle]="{ backgroundColor: massiveOperationColor }" (click)="sendIdList()"
        class="ald-mat-button primary">
        {{ massiveOperationText }}
      </button>
    </div>

    <div *ngIf="secondMassiveOperationObj" class="gap-0 gap-xs-[10px] ml-1">
      <button mat-raised-button [ngStyle]="{ backgroundColor: secondMassiveOperationColor }" (click)="sendIdList2()"
        class="ald-mat-button primary">
        {{ secondMassiveOperationText }}
      </button>
    </div>

    <div *ngIf="massiveOperationObjDelegation && profile.role !== '10' && profile.role !== '11'"
      class="gap-0 gap-xs-[10px]">
      <button mat-raised-button [ngStyle]="{ backgroundColor: massiveOperationColorDelegation }" (click)="sendIdList()"
        class="ald-mat-button primary">
        {{ massiveOperationTextDelegation }}
      </button>
    </div>

    <div *ngIf="exportExcel && count > 0 && !loading" class="button-container flex flex-wrap content-start items-start w-full order-2 self-start gap-2.5 
            md:flex-row md:w-[60%] md:order-1 md:gap-x-[10px] md:gap-y-0">
      <button mat-stroked-button class="ald-mat-button font-small blue margin-button" (click)="onClickExport(false)">
        <mat-icon fontSet="fa" fontIcon="fa-file-excel"></mat-icon>
        {{ "full_download" | i18n | uppercase }}
      </button>
      <!-- 
        *Attualmente disabilitato in quanto si ritiene non utile il download puntuale 
        delle fatture in formato excel*
        <button
        [disabled]="!isCheckboxSelected"
        mat-stroked-button
        class="ald-mat-button font-small blue margin-button"
        (click)="onClickExport(false)"
      >
        <mat-icon fontSet="fa" fontIcon="fa-file-excel"></mat-icon>
        {{ "selected_download" | i18n | uppercase }}
      </button> -->
      <button *ngIf="exportFilter" mat-stroked-button class="ald-mat-button font-small blue margin-button"
        (click)="onClickExport(true)">
        <mat-icon fontSet="fa" fontIcon="fa-file-excel"></mat-icon>
        {{ "filtered_download" | i18n | uppercase }}
      </button>
      <button *ngIf="showZipDownloadButton" [disabled]="!isCheckboxSelected" mat-stroked-button
        class="ald-mat-button font-small blue margin-button" (click)="onClickDownloadZip(false)">
        <mat-icon fontSet="fa" fontIcon="fa-file-zip-o" class="pdf-icon"></mat-icon>
        {{ "selected_download_zip" | i18n | uppercase }}
      </button>
      <button *ngIf="showZipDownloadButton" mat-stroked-button class="ald-mat-button font-small blue margin-button"
        (click)="onClickDownloadZip(true)">
        <mat-icon fontSet="fa" fontIcon="fa-file-zip-o" class="pdf-icon"></mat-icon>
        {{ "selected_download_zip_all" | i18n | uppercase }}
      </button>
    </div>
    <!--EXPORTPDF-->
    <div *ngIf="exportPdf && count > 0 && !loading" class="button-container flex flex-wrap content-start items-start w-full order-2 self-start gap-2.5 
            md:flex-row md:w-[60%] md:order-1 md:gap-x-[10px] md:gap-y-0">
      <button *ngIf="exportFilter" mat-stroked-button class="ald-mat-button font-small blue margin-button"
        (click)="onClickExport(true)">
        <mat-icon fontSet="fa" fontIcon="fa-file-excel"></mat-icon>
        {{ "filtered_download" | i18n | uppercase }}
      </button>
      <button *ngIf="showZipDownloadButton" [disabled]="!isCheckboxSelected" mat-stroked-button
        class="ald-mat-button font-small blue margin-button" (click)="onClickDownloadZip(false)">
        <mat-icon fontSet="fa" fontIcon="fa-file-zip-o" class="pdf-icon"></mat-icon>
        {{ "selected_download_zip" | i18n | uppercase }}
      </button>
      <button *ngIf="showZipDownloadButton" mat-stroked-button class="ald-mat-button font-small blue margin-button"
        (click)="onClickDownloadZip(true)">
        <mat-icon fontSet="fa" fontIcon="fa-file-zip-o" class="pdf-icon"></mat-icon>
        {{ "selected_download_zip_all" | i18n | uppercase }}
      </button>
    </div>
    <!--Fine-->
    <div *ngIf="multiplePdfDownload && count > 0 && !loading" class="button-container flex flex-wrap content-start items-start w-full order-2 self-start gap-2.5 
            md:flex-row md:w-[60%] md:order-1 md:gap-x-[10px] md:gap-y-0">
      <button mat-stroked-button [disabled]="!isCheckboxSelected" class="ald-mat-button font-small blue"
        (click)="onClickExportPDF(false)">
        <mat-icon fontSet="fa" fontIcon="fa-file-pdf" class="pdf-icon"></mat-icon>
        {{ "selected_download" | i18n | uppercase }}
      </button>
      <button *ngIf="exportFilter" mat-stroked-button class="ald-mat-button font-small blue"
        (click)="onClickExportPDF(true)">
        <mat-icon fontSet="fa" fontIcon="fa-file-pdf" class="pdf-icon"></mat-icon>
        {{ "filtered_download" | i18n | uppercase }}
      </button>
    </div>
      <pagination-template *ngIf="!!table && count > 0 && !loading" class="pagination-container flex flex-col w-full order-1 self-start
         md:w-[40%] md:order-2 md:self-end" #p="paginationApi" [id]="paginationId" [maxSize]="7"
                           (pageChange)="pageChange($event)">
      <div class="pagination-row">
        <div class="pagination-pages" *ngIf="p.pages?.length > 1">
          <div class="pagination-previous">
            <div class="pagination-arrow ald-text-main-color" *ngIf="!p.isFirstPage()" (click)="p.previous()">
              <mat-icon>navigate_before</mat-icon>
            </div>
          </div>
          <div class="pagination-page" *ngFor="let page of p.pages">
            <div (click)="p?.setCurrent(page.value)" *ngIf="p?.getCurrent() !== page.value">
              {{ page?.label }}
            </div>
            <div class="ald-text-main-color" *ngIf="p?.getCurrent() === page.value">
              {{ page?.label }}
            </div>
          </div>
          <div class="pagination-arrow ald-text-main-color" [class.disabled]="p.isLastPage()" *ngIf="!p.isLastPage()">
            <div (click)="p.next()">
              <mat-icon>navigate_next</mat-icon>
            </div>
          </div>
        </div>

        <div class="pagination-info">
          <div [innerHTML]="getPageInfo(p)"></div>
        </div>
      </div>
    </pagination-template>
  </div>
</mat-card>
